import { render } from "./MotivaterShipComponent.vue?vue&type=template&id=445e853b&scoped=true"
import script from "./MotivaterShipComponent.vue?vue&type=script&lang=js"
export * from "./MotivaterShipComponent.vue?vue&type=script&lang=js"

import "./MotivaterShipComponent.vue?vue&type=style&index=0&id=445e853b&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/tribuk-ui/tribuk-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-445e853b"]])

export default __exports__